import { fetchWrapper } from "../../app/sagas/fetchSagaFactory";

import {
	CreateInvitationRequest,
	CreateInvitationResponse,
	InvitationDto,
	isCreateInvitationResponse,
	isInvitationDto,
	isInvitationDtoArray
} from "./types";

export async function getInvitations(applicationKey: string): Promise<InvitationDto[]> {
	const response = await fetchWrapper({
		method: "GET",
		relativeUrl: `/invitations/${encodeURIComponent(applicationKey)}`
	});
	const data: unknown = await response.json();
	if (!isInvitationDtoArray(data)) {
		throw new Error("Unexpected response format from GET /invitations/" + applicationKey);
	}
	return data;
}

export async function createInvitations(
	appKey: string,
	request: CreateInvitationRequest
): Promise<CreateInvitationResponse> {
	const response = await fetchWrapper({
		method: "POST",
		relativeUrl: `/invitations/${appKey}`,
		body: JSON.stringify(request),
		customHeaders: [["Content-Type", "application/json"]]
	});
	const data = await response.json();
	if (!isCreateInvitationResponse(data)) {
		throw new Error("Unexpected response format from POST /invitations");
	}
	return data;
}

export async function deleteInvitation(applicationKey: string, tokenHash: string): Promise<void> {
	await fetchWrapper({
		method: "DELETE",
		relativeUrl: `/invitations/${encodeURIComponent(applicationKey)}/${encodeURIComponent(tokenHash)}`
	});
}

export async function revokeInvitation(applicationKey: string, tokenHash: string): Promise<InvitationDto> {
	const response = await fetchWrapper({
		method: "PUT",
		relativeUrl: `/invitations/${encodeURIComponent(applicationKey)}/${encodeURIComponent(tokenHash)}/revoke`
	});
	const data: unknown = await response.json();
	if (!isInvitationDto(data)) {
		throw new Error("Unexpected response format from PUT /invitations/.../revoke");
	}
	return data;
}

export async function resendInvitation(applicationKey: string, tokenHash: string): Promise<InvitationDto> {
	const response = await fetchWrapper({
		method: "PUT",
		relativeUrl: `/invitations/${encodeURIComponent(applicationKey)}/${encodeURIComponent(tokenHash)}/resend`
	});
	const data: unknown = await response.json();
	if (!isInvitationDto(data)) {
		throw new Error("Unexpected response format from PUT /invitations/.../resend");
	}
	return data;
}
